import React from 'react';
import styled from 'styled-components';
import Item from './Item';

const DepartmentMain = styled.div`
                            background: #F5F5F5;
                            padding: 0px 40px;
                            margin: 0px 0px 20px 0px;
                            text-align:center;
                            .month-title{
                               display:block; 
                               margin-bottom:10px;
                            }
                            .left-border{
                                border-left:1px solid rgba(0,0,0,.125);
                            }
                            .right-border{
                                border-right:1px solid rgba(0,0,0,.125);
                            }
                            .border-both{
                                border-right:1px solid rgba(0,0,0,.125);
                                border-left:1px solid rgba(0,0,0,.125);
                            }
`
const getMonths = () => {
    let monthNames = [

        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"

    ];

    let months = [];
    let now = new Date();

    months.push({ 'name': monthNames[now.getMonth()], 'month': now.getMonth() + 1 });
    months.push({ 'name': monthNames[now.getMonth() + 1], 'month': now.getMonth() + 2 });
    months.push({ 'name': monthNames[now.getMonth() + 2], 'month': now.getMonth() + 3 });

    return months;
}

const Summary = (props) => {
    const months = getMonths();

    return (
        <DepartmentMain>
            <div className="row">
                <div className="col-2">
                    <span className="title"></span>
                </div>
                <div className="col-8 px-0">
                    <div className="row">
                        <div className="col-12 px-0">
                            <div className="row">
                                {months.map((month, index) => (
                                    <div className={`col-sm-12 col-md-4 px-4 pt-2  ${index === 0 ? 'left-border' : index === 1 ? 'border-both' : 'border-right'}`} key={index}>
                                        <span className="month-title">{month.name}</span>
                                        {props.activities.filter(activity => activity.finish.indexOf(month.month + '-') !== -1)

                                            .map((item, index) => (
                                                <Item item={item} key={index} />
                                            )
                                            )}
                                    </div>
                                )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-2">

                </div>
            </div>
        </DepartmentMain>
    );
}

export default Summary;